export default "__VITE_ASSET__Oed3TkkL__"